import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type Language } from './index';

/**
 * 現在の言語を `'en' | 'ja'` として返す。
 *
 * i18n.language は `en-US` のような地域付きや未知の値になりうるので、ここで必ず
 * サポート言語に丸める。**コンポーネントは album データを `data[lang]` の形で引く**ため、
 * 丸めないと `undefined` を描画してしまう（型では防げない）。
 */
export function useLanguage(): Language {
  const { i18n } = useTranslation();
  const base = i18n.language?.split('-')[0];
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(base) ? (base as Language) : 'en';
}
